module.exports = {"id":"204830","name":"Vadillo","rating":"71","photo":"./data/images/photos/1/204830.png","club":{"name":"SD Huesca","logo":"./data/images/clubs/SDHuesca.png"},"positions":["MG","AG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Vadillo0.json
// module id = 4215
// module chunks = 0